export const environment = {
    production: false,
    apiUrl: 'https://api-dev.alaga.ph',
    featureFlag: true
};
